/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from "react-intl";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import { AsideMenuItem } from "./AsideMenuItem";
import { ProtectedMenuItem } from "../../../../app/permissions";

export function AsideMenuMain() {
  const intl = useIntl();

  return (
    <>
      <div style={{ marginBottom: "60px" }}>
        {/* dashboard  */}
        <AsideMenuItem
          to="/dashboard"
          icon="/media/icons/sidebarIcon/Dashboard.svg"
          title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
          fontIcon="bi-app-indicator"
        />

        {/* crop menu start */}
        <ProtectedMenuItem
          requiredPermissions={["cropList", "diseaseAndPestList"]}
        >
          <AsideMenuItemWithSub
            to=""
            title="Crop and Disease"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/DiseaseInsects.svg"
          >
            <ProtectedMenuItem requiredPermissions={["cropList"]}>
              <AsideMenuItemWithSub
                to=""
                title="Crop"
                fontIcon="bi-chat-left"
                icon="/media/icons/sidebarIcon/Crops.svg"
              >
                <AsideMenuItem
                  to="/all-crop"
                  title="all Crop"
                  hasBullet={true}
                />

                <AsideMenuItem
                  to="/crop-category"
                  title="Crop Category"
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["diseaseAndPestList"]}>
              <AsideMenuItem
                to="/disease-insect"
                title="Disease and Insect"
                hasBullet={true}
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["diseaseDetectionList"]}>
              <AsideMenuItem
                to="/disease-detection"
                title="Disease Detection"
                hasBullet={true}
              />
            </ProtectedMenuItem>
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>
        {/* crop menu end */}

        {/* product menu start */}
        <ProtectedMenuItem requiredPermissions={["productList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Product"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/products.svg"
          >
            <AsideMenuItem to="/products" title="Products" hasBullet={true} />

            <AsideMenuItem
              to="/pending-products"
              title="Pending Products"
              hasBullet={true}
            />

            <AsideMenuItem
              to="/landing-pages"
              title="Landing Pages"
              hasBullet={true}
            />

            <ProtectedMenuItem requiredPermissions={["productCategoryList"]}>
              <AsideMenuItemWithSub
                to=""
                title="Settings"
                fontIcon="bi-chat-left"
                icon="/media/icons/sidebarIcon/GenericGroup.svg"
              >
                <AsideMenuItem
                  to="/product-category"
                  title="Category"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-sub-category"
                  title="Sub Category"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-color-code"
                  title="Color Code"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-company"
                  title="Company"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-element"
                  title="Element"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/generic-group"
                  title="Generic Group"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-size"
                  title="Size"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-solution"
                  title="Solution"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/product-unit-type"
                  title="Unit"
                  hasBullet={true}
                />
                <AsideMenuItem
                  to="/working-mood"
                  title="Working Mood"
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>
            </ProtectedMenuItem>
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>
        {/* product menu end */}

        {/* order menu start */}
        <ProtectedMenuItem requiredPermissions={["orderList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Order"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/Order.svg"
          >
            <AsideMenuItem
              to="/order/pending-order"
              title="Pending Orders"
              hasBullet={true}
            />
            <AsideMenuItem
              to="/order/approved-order"
              title="Approved Orders"
              hasBullet={true}
            />
            <AsideMenuItem
              to="/order/complete-order"
              title="Complete Orders"
              hasBullet={true}
            />
            <AsideMenuItem
              to="/order/cancelled-order"
              title="Cancelled Orders"
              hasBullet={true}
            />
            <AsideMenuItem
              to="/order/return-or-refund"
              title="Return Or Refund"
              hasBullet={true}
            />
            <AsideMenuItem
              to="/order/manual-order"
              title="Manual Orders"
              hasBullet={true}
            />
            {/* Dr. Chashi Mart checkouts left without ordering — backend serves
                roles 1 and 5 only, hence its own key (role 4 has orderList) */}
            <ProtectedMenuItem requiredPermissions={["orderIncompleteList"]}>
              <AsideMenuItem
                to="/order/incomplete-order"
                title="Incomplete Orders"
                hasBullet={true}
              />
            </ProtectedMenuItem>
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>
        {/* order menu end */}

        {/* early warning menu start */}
        <ProtectedMenuItem requiredPermissions={["earlyWarningList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Early Warning"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/EarlyWarning.svg"
          >
            <ProtectedMenuItem requiredPermissions={["warningCategoryList"]}>
              <AsideMenuItem
                to="/warning-category"
                title="category"
                hasBullet={true}
              />
            </ProtectedMenuItem>

            <AsideMenuItem
              to="/early-warning"
              title="Warning"
              hasBullet={true}
            />
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>
        {/*early warning menu end */}

        <ProtectedMenuItem requiredPermissions={["stockList"]}>
          <AsideMenuItem
            to="/stock"
            title="Stock"
            fontIcon="bi-layers"
            icon="/media/icons/sidebarIcon/Stock.svg"
          />
        </ProtectedMenuItem>

        <ProtectedMenuItem requiredPermissions={["courseList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Course"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/Course.svg"
          >
            <AsideMenuItem to="/course" title="all Course" hasBullet={true} />

            <ProtectedMenuItem requiredPermissions={["courseCategoryList"]}>
              <AsideMenuItem
                to="/course-category"
                title="Course Category"
                hasBullet={true}
              />
            </ProtectedMenuItem>
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>

        <ProtectedMenuItem requiredPermissions={["dealerList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Dealer"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/Dealer.svg"
          >
            <AsideMenuItem to="/dealer" title="all Dealer" hasBullet={true} />

            <AsideMenuItem
              to="/pending-dealer"
              title="Pending Dealer"
              hasBullet={true}
            />

            <ProtectedMenuItem requiredPermissions={["paymentMethodList"]}>
              <AsideMenuItemWithSub
                to=""
                title="Payment Method"
                fontIcon="bi-chat-left"
                icon="/media/icons/sidebarIcon/Money.svg"
              >
                <AsideMenuItem
                  to="/approved-payment-method"
                  title="Approved"
                  hasBullet={true}
                />

                <AsideMenuItem
                  to="/pending-payment-method"
                  title="Pending"
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>
            </ProtectedMenuItem>
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>

        <ProtectedMenuItem requiredPermissions={["accountLeadList"]}>
          <AsideMenuItem
            to="/account-lead"
            title="Dealer Account Lead"
            // hasBullet={true}
            icon="/media/icons/sidebarIcon/TeamConsultant.svg"
          />
        </ProtectedMenuItem>

        <ProtectedMenuItem requiredPermissions={["bannerList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Configuration"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/Settings.svg"
          >
            <AsideMenuItem
              to="/banner"
              title="Banner"
              // hasBullet={true}
              icon="/media/icons/sidebarIcon/Banner.svg"
            />

            <ProtectedMenuItem requiredPermissions={["chadBaganTipsList"]}>
              <AsideMenuItem
                to="/chad-bagan-tips"
                title="Chad Bagan Tips"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/FAQ.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["faqList"]}>
              <AsideMenuItem
                to="/faq"
                title="FAQ"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/FAQ.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["farmerSafetyList"]}>
              <AsideMenuItem
                to="/farmer-safety"
                title="Farmer Safety"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/FarmerSafety.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["featureList"]}>
              <AsideMenuItem
                to="/feature"
                title="Feature"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/Leaf.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["mediaList"]}>
              <AsideMenuItem
                to="/gallery"
                title="Gallery"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/Gallery.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["professionList"]}>
              <AsideMenuItem
                to="/profession"
                title="Profession"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/Profession.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["referenceList"]}>
              <AsideMenuItem
                to="/reference"
                title="Reference"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/Reference.svg"
              />
            </ProtectedMenuItem>

            <ProtectedMenuItem requiredPermissions={["teamConsultantList"]}>
              <AsideMenuItem
                to="/team-consultant"
                title="Team Consultant"
                // hasBullet={true}
                icon="/media/icons/sidebarIcon/TeamConsultant.svg"
              />
            </ProtectedMenuItem>
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>

        <ProtectedMenuItem requiredPermissions={["martList"]}>
          <AsideMenuItemWithSub
            to=""
            title="Mart"
            fontIcon="bi-chat-left"
            icon="/media/icons/sidebarIcon/products.svg"
          >
            <AsideMenuItemWithSub
              to=""
              title="Services"
              fontIcon="bi-chat-left"
              icon="/media/icons/sidebarIcon/Settings.svg"
            >
              <AsideMenuItem
                to="/soil-sensor-booking"
                title="Soil Sensor"
                icon="/media/icons/sidebarIcon/EarlyWarning.svg"
              />

              <AsideMenuItem
                to="/rooftop-booking"
                title="Rooftop Service"
                icon="/media/icons/sidebarIcon/WorkingMood.svg"
              />

              <AsideMenuItem
                to="/home-service-booking"
                title="Home Expert"
                icon="/media/icons/sidebarIcon/TeamConsultant.svg"
              />
            </AsideMenuItemWithSub>

            <AsideMenuItem
              to="/contact-request"
              title="Contact Request"
              icon="/media/icons/sidebarIcon/Reference.svg"
            />

            <AsideMenuItem
              to="/newsletter-subscriber"
              title="Newsletter Subscribers"
              icon="/media/icons/sidebarIcon/Banner.svg"
            />
          </AsideMenuItemWithSub>
        </ProtectedMenuItem>
      </div>
    </>
  );
}
